import { createFileRoute } from "@tanstack/react-router"
import { Crumb } from "modules/shared/lib/breadcrumbs"

import "modules/capabilities/lang"

export const Route = createFileRoute("/_base/_auth/capabilities")({
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("capabilities.title"),
    })
  },
})
